import React from 'react';

import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';
import { Hyperlink, Image } from '@openedx/paragon';

import messages from './messages';

const MediumLayout = () => {
  const { formatMessage } = useIntl();

  return (
    <>
      <div className="w-100 medium-screen-top-stripe" />
      <div className="w-100 p-0 mb-3 d-flex">
        <div className="col-md-10 bg-primary-400">
          <Hyperlink destination={getConfig().MARKETING_SITE_BASE_URL}>
            <Image alt={getConfig().SITE_NAME} className="logo" src={getConfig().LOGO_WHITE_URL} />
            <span className="auth-brand-name d-none" aria-hidden="true">{getConfig().SITE_NAME}</span>
          </Hyperlink>
          <div className="d-flex align-items-center justify-content-center mb-4 ">
            <div className="mt-1 medium-blue-line" />
            <div className="auth-brand-copy">
              <h1 className="display-1 text-white auth-heading-text">
                <span className="auth-heading-highlight">{formatMessage(messages['authn.brand.learn'])}</span>{' '}
                <span>{formatMessage(messages['authn.brand.practice'])}</span>{' '}
                <span>{formatMessage(messages['authn.brand.connect'])}</span>
              </h1>
              <p className="auth-tagline d-none">{formatMessage(messages['authn.brand.tagline'])}</p>
            </div>
          </div>
        </div>
        <div className="col-md-2 bg-white p-0">
          <svg className="w-100 h-100 medium-screen-svg-primary" preserveAspectRatio="xMaxYMin meet">
            <g transform="skewX(168)">
              <rect x="0" y="0" height="100%" width="100%" />
            </g>
          </svg>
        </div>
      </div>
    </>
  );
};

export default MediumLayout;
